import { put, takeLatest } from 'redux-saga/effects';
import { CARDS_ACTIONS, CARDS_LOADERS } from './utils';
import { getAllCards, removeMethod, setCards, toggleLoader } from './reducer';

import { toast } from 'sonner';
import { getPaymentMethods } from '@/api/requests/endpoints/GET/getPaymentMethods';
import { deletePaymentMethod } from '@/api/requests/endpoints/POST/deletePaymentMethod';

function* getAllCardsSaga() {
  try {
    yield put(
      toggleLoader({
        key: CARDS_LOADERS.GET_CARDS,
        value: true,
      }),
    );
    const res = yield getPaymentMethods();

    if (!res.cards) {
      throw new Error('Something went wrong');
    }
    yield put(setCards(res.cards));
  } catch (e) {
    console.log(e);
    toast.error('Si è verificato un errore! ', {
      description: 'Non è stato possibile recuperare le tue carte. Riprova! ',
    });
  } finally {
    yield put(
      toggleLoader({
        key: CARDS_LOADERS.GET_CARDS,
        value: false,
      }),
    );
  }
}

function* deletePaymentMethodSaga({
  payload,
}: ReturnType<typeof removeMethod>) {
  try {
    yield put(
      toggleLoader({ key: CARDS_LOADERS.DELETE_PAYMENT_METHOD, value: true }),
    );
    const response = yield deletePaymentMethod(payload);
    if (response?.error) {
      throw new Error('Somenthing went wrong');
    }
    yield put(getAllCards());
  } catch (e) {
    toast.error('Si è verificato un errore! ', {
      style: {
        backgroundColor: '#ff0033',
        color: '#FFF',
      },
      position: 'top-right',
      description: 'Non è stato possibile eliminare il metodo di pagamento! ',
    });
  } finally {
    yield put(
      toggleLoader({ key: CARDS_LOADERS.DELETE_PAYMENT_METHOD, value: false }),
    );
  }
}

export function* cardsSaga() {
  yield takeLatest(CARDS_ACTIONS.GET_CARDS, getAllCardsSaga);
  yield takeLatest(
    CARDS_ACTIONS.DELETE_PAYMENT_METHOD,
    deletePaymentMethodSaga,
  );
}
